import React from "react";
import { useSelector } from "react-redux";
import "./topBar.css";
import { S3_BASE_URL } from "../../../../../Service";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { selectSiteData } from "../../../../../store/selectors/commonSelectors";

const TopHeader = () => {
  const siteData = useSelector(selectSiteData);
  const { defaultphones } = useSelector((state) => state.data);

  
  // const getLogoUrl = (url) => {
  //   if (!url) return "";
  //   if (url.startsWith("http")) return url;
  //   const formattedUrl = url.startsWith("/") ? url : `/${url}`;
  //   return `${S3_BASE_URL}${formattedUrl}`;
  // };

    const getLogoUrl = (url) => {
      if (typeof url !== "string") return "";
      if (url.startsWith("http")) return url;
      const formattedUrl = url.startsWith("/") ? url : `/${url}`;
      return `${S3_BASE_URL}${formattedUrl}`;
    };

   const handleClick = () => {
   window.scrollTo({
      top: 0,
      behavior: "smooth",
    });  };

  return (
    <div className="topbar-area hidden-md" id="extraP">
      <div className="container">
        <div className="row">
          <div className="col-lg-2">
            <div className="logo-part">
              <Link to="/" onClick ={handleClick}>
                <img src={getLogoUrl(siteData?.logo1)} alt="Logo" />
              </Link>
            </div>
          </div>
          <div className="col-lg-10 text-right">
            <ul className="rs-contact-info">
              <li className="contact-part">
                <i className="flaticon-email"></i>
                <span className="contact-info">
                  <span>E-mail</span>
                  <a
                      href={`mailto:${siteData.email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {siteData.email}
                  </a>
                </span>
              </li>
              <li className="contact-part">
                <i className="flaticon-call"></i>
                <span className="contact-info">
                  <span>Phone</span>
                  <a href="tel:+919654652847">{defaultphones}</a>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* {!htmlContent ? (
        ""
      ) : (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      )} */}
    </div>
  );
};

export default TopHeader;
